import PartnersIntro from "./_partials/PartnersIntro";
import PartnerRow from "./_partials/PartnerRow";

const PARTNERS = [
  {
    name: "Healthie",
    role: "Integration-First EHR",
    lines: [
      "Our core EHR — open, integration-first, letting every clinical, behavioral, and biometric signal flow into one unified patient record.",
    ],
  },
  {
    name: "Keragon",
    role: "Healthcare Workflow Automation",
    lines: [
      "HIPAA-compliant automation connecting EHRs, intake, labs, and messaging — so our care team focuses on patients, not paperwork.",
    ],
  },
  {
    name: "Notion",
    role: "Enterprise Workspace",
    lines: [
      "Enterprise partnership powering our clinical SOPs, program design, research, and team collaboration in one connected system.",
    ],
  },
  {
    name: "Jotform",
    role: "AI Agents & Intelligent Forms",
    lines: [
      "Powers every patient-facing AI agent and adaptive intake form — including Rhea, the Integrated Optimization Agent.",
    ],
  },
  {
    name: "Spruce Health",
    role: "HIPAA-Compliant Patient Communication",
    lines: [
      "Secure messaging, voice, and video — every conversation and clinical touchpoint inside one encrypted system.",
    ],
  },
  {
    name: "Emergent",
    role: "AI Engineering Partner",
    lines: [
      "The Integrated Clinical Intelligence platform, AI agents, and patient flows are built natively on Emergent — where we rank among its top platform builders.",
    ],
  },
  {
    name: "Hugging Face",
    role: "AI Model & Agent Hosting",
    lines: [
      "Hosts the open-source AI models behind our clinical intelligence — open science and reproducible AI, without provider lock-in.",
    ],
  },
  {
    name: "Slack",
    role: "Clinical & Operations Comms",
    lines: [
      "Real-time communication backbone for our clinical, engineering, and operations teams — integrated with our core platforms.",
    ],
  },
  {
    name: "Salesforce",
    role: "Patient Relationship Platform",
    lines: [
      "Enterprise CRM tracking every conversation, referral, and enrollment — plus our partnership and enterprise pipeline.",
    ],
  },
  {
    name: "GitHub",
    role: "Source Control & Engineering",
    lines: [
      "Version-controlled, audit-friendly engineering — every change reviewed, every deployment traceable.",
    ],
  },
];

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative py-24 md:py-36 bg-foreground text-background overflow-hidden"
    >
      {/* Subtle vertical rule running down the dark panel for editorial gravitas */}
      <div
        aria-hidden
        className="absolute inset-y-0 left-1/2 w-px bg-background/5 pointer-events-none hidden md:block"
      />

      <div className="relative max-w-6xl mx-auto px-4 md:px-8">
        <PartnersIntro />

        <ul className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {PARTNERS.map((p, i) => (
            <PartnerRow key={p.name} partner={p} index={i} />
          ))}
        </ul>

        <p className="mt-8 max-w-3xl font-mono text-[0.65rem] uppercase tracking-[0.22em] text-background/45 leading-relaxed">
          All technology partners selected for HIPAA-aware data handling, enterprise-grade
          security, and clinical reliability.
        </p>
      </div>
    </section>
  );
}
